import type { RawAxiosRequestHeaders } from 'axios'
import type { CacheRequestConfig } from 'axios-cache-interceptor'
import type { IOfferVisitSSO, IOfferVisitSSORequest } from '~/types/offer.visit.sso.types'
import type { ISSOConfig, ISSOConfigRequest } from '~/types/sso.config.types'
import webConfig from '~/config'
import { HTTP_METHOD } from '~/types/http.types'
import HttpClient from './axios'

const headers: RawAxiosRequestHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'App-Version': webConfig.app.version,
}

class PlatformApi extends HttpClient {
  public constructor() {
    super(webConfig.api.platform_api_url, headers)
  }

  public run = async <T>(method: HTTP_METHOD, path: string, data?: any, requestConfig?: CacheRequestConfig) => {
    switch (method) {
      case HTTP_METHOD.POST:
        return await this.api.post<T>(`${webConfig.api.platform_api_url}${path}`, data, requestConfig)
      case HTTP_METHOD.PUT:
        return await this.api.put<T>(`${webConfig.api.platform_api_url}${path}`, data, requestConfig)
      case HTTP_METHOD.DELETE:
        return await this.api.delete<T>(`${webConfig.api.platform_api_url}${path}`, requestConfig)
      case HTTP_METHOD.PATCH:
        return await this.api.patch<T>(`${webConfig.api.platform_api_url}${path}`, data, requestConfig)
      case HTTP_METHOD.GET:
      default:
        return await this.api.get<T>(`${webConfig.api.platform_api_url}${path}`, requestConfig)
    }
  }

  public getSSOConfig = async (memberId: string, ssoConfigRequest: ISSOConfigRequest) => {
    return await this.run<ISSOConfig[]>(
      HTTP_METHOD.GET,
      `members/${memberId}/sso_configs`,
      undefined,
      {
        params: ssoConfigRequest,
      },
    )
  }

  public postVisitSSO = async (offerId: string, offerVisitSSORequest: IOfferVisitSSORequest) => {
    return await this.run<IOfferVisitSSO>(
      HTTP_METHOD.POST,
      `offers/${offerId}/visit_sso`,
      offerVisitSSORequest,
      {
        headers: {
          'Olive-Member': offerVisitSSORequest.memberId,
          'Olive-SSO-Destination': offerVisitSSORequest.ssoDestination,
          'Authorization': `Bearer ${offerVisitSSORequest.ssoAccessToken}`,
        },
      },
    )
  }
}

const singleton = new PlatformApi()
export default singleton
